import * as betprofessor from './Filters.styles.betprofessor';
import * as betroyale from './Filters.styles.betroyale';
import * as fiestabet from './Filters.styles.fiestabet';
import * as puntcity from './Filters.styles.puntcity';
import * as puntgenie from './Filters.styles.puntgenie';
import * as questbet from './Filters.styles.questbet';
import * as sterlingparker from './Filters.styles.sterlingparker';
import * as vikingbet from './Filters.styles.vikingbet';
import * as volcanobet from './Filters.styles.volcanobet';
import * as wellbet from './Filters.styles.wellbet';
import * as juicybet from './Filters.styles.juicybet';
import * as goldenrush from './Filters.styles.goldenrush';
import * as forsport from './Filters.styles.forsport';
import * as junglebet from './Filters.styles.junglebet';
import * as sugarcastle from './Filters.styles.sugarcastle';
import * as oldgill from './Filters.styles.oldgill';
import * as buffalobet from './Filters.styles.buffalobet';
import * as titanbet from './Filters.styles.titanbet';
import * as slambet from './Filters.styles.slambet';
import * as gigabet from './Filters.styles.gigabet';
import * as betstride from './Filters.styles.betstride';
import * as templebet from './Filters.styles.templebet';
import * as goldenbet888 from './Filters.styles.goldenbet888';
import * as hyperbet from './Filters.styles.hyperbet';
import * as bet777 from './Filters.styles.bet777';
import * as chromabet from './Filters.styles.chromabet';
import * as bet575 from './Filters.styles.bet575';
import * as epicodds from './Filters.styles.epicodds';
import * as pyramidbet from './Filters.styles.pyramidbet';
import * as magnumbet from './Filters.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betprofessor,
  betroyale,
  fiestabet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  juicybet,
  goldenrush,
  forsport,
  junglebet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
